module.exports = __webpack_public_path__ + "./images/1487c87c6126cb0af589a52a23f578ca.webp";